import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/authContext";

export default function ScreenTranslatorPage() {
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();
  const [userNickname, setUserNickname] = useState('');
   const navigate = useNavigate();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    navigate("/login");
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">스크린번역기 (Screen Translator)</h1>
            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">메인페이지로 이동</Link>
              <span className="mx-2">|</span>
              <Link to="/screen-translator" className="hover:text-blue-400">스크린번역기 (Screen Translator)</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
              <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
              </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                  Sign out
                </button>
              ) : (
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                  Sign in
                </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
            {isLoggedIn && (
              <Link
                to="/mypage"
                className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
              >
                MyPage
              </Link>
            )}
            </div>
          </div>
        </header>
        <div className="bg-gray-900 text-white">
        <section className="mx-auto max-w-4xl px-4 py-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold mb-2">스크린 번역기 (Screen Translator)</h1>
          <p className="text-gray-300">화면 위 특정 영역을 드래그하여 원하는 언어로 번역하는 데스크톱 유틸리티입니다.</p>

          <br/>
          <p className="text-gray-500">※ 스크린번역기(ScreenTranslator)는 비회원은 이용이 불가하며, 로그인 후 일일 무료 횟수 및 남은 횟수로 이용이 가능합니다.
          </p>

          <div className="mt-6">
            <a
              href="/downloads/JU_ScreenTranslator_v1.1.zip"
              download
              className="inline-block px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 font-semibold"
            >
              ⬇️ 설치파일 다운로드 (.exe)
            </a>
          </div>

          <div className="mt-6">
            <a
              href="https://lcoding.tistory.com/216"
              className="inline-block px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 font-semibold"
            >
              ✨ 사용 방법 링크
            </a>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-4">
              <div className="font-semibold mb-2">주요 기능</div>
              <ul className="list-disc pl-5 text-gray-300 text-sm space-y-1">
                <li>드래그 영역 캡처 · OCR(영/한/일 등) · 자동 언어 감지</li>
                <li>번역 결과 오버레이 출력</li>
                <li>실행 파일(.exe) 제공</li>
              </ul>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-xl p-4">
              <div className="font-semibold mb-2">시스템 요구 사항 (권장)</div>
              <ul className="list-disc pl-5 text-gray-300 text-sm space-y-1">
                <li>Windows 10/11 (x64), 메모리 4GB+</li>
                <li>인터넷 연결 가능한 환경</li>
              </ul>
            </div>
          </div>

          <div className="mt-8 bg-gray-800 border border-gray-700 rounded-xl p-4">
            <div className="font-semibold mb-2">사용 방법</div>
            <ol className="list-decimal pl-5 text-gray-300 text-sm space-y-1">
              <li>설치 파일을 내려받아 실행합니다. SmartScreen 경고가 뜨면 ‘추가 정보’ → ‘실행’.</li>
              <li>프로그램 실행 후 <b>로그인</b> -> <b>로그인하기</b> -> 이메일과 비밀번호를 입력 후 <b>로그인</b>합니다.</li>
              <li>로그인 후에 반투명 창으로 번역할 영역을 감싼 뒤 <b>번역</b> 클릭.</li>
              <li>자동으로 언어를 감지하여 표시해주고 선택한 언어로 번역된 결과를 표시합니다.</li>
              <li>(선택사항) 우측 상단에서 번역 출력 언어의 변경이 가능합니다.</li>
            </ol>
          </div>

          <div className="mt-4 bg-gray-800 border border-gray-700 rounded-xl p-4">
            <div className="font-semibold mb-2">문제 해결</div>
            <ul className="list-disc pl-5 text-gray-300 text-sm space-y-1">
              <li>SmartScreen 차단: ‘추가 정보’ → ‘실행’</li>
              <li>언어 인식률이 낮을 경우 캡처 영역 확대 또는 축소</li>
              <li>네트워크 오류: 인터넷 연결 및 남은 횟수 확인</li>
            </ul>
          </div>

          <br/>
          {/* 설치 전 안내 */}
          <div className="rounded-2xl border p-5 mb-6">
            <h2 className="text-lg font-semibold mb-3">🖥 설치 전 준비 (Windows)</h2>
            <ol className="list-decimal pl-5 space-y-2 text-sm">
              <li>
                <span className="font-medium">Windows 보안</span> 열기 → <span className="font-medium">바이러스 및 위협 방지</span> →
                <span className="font-medium"> 바이러스 및 위협 방지 설정</span>에서 <span className="font-medium">설정 관리</span> 클릭
              </li>
              <li>
                <span className="font-medium">제외</span> → <span className="font-medium">제외 추가 또는 제거</span> →
                <span className="font-medium">폴더 제외</span> 선택 → 압축 풀 위치(예: <code className="bg-gray-100 text-gray-700 px-1 rounded">C:\Users\사용자\Desktop\juFile</code>)를 등록
              </li>
            </ol>
          </div>

          {/* 설치 방법 */}
          <div className="rounded-2xl border p-5 mb-6">
            <h2 className="text-lg font-semibold mb-3">📦 설치 & 실행</h2>
            <ol className="list-decimal pl-5 space-y-2 text-sm">
              <li>압축 해제 후 폴더 안의 <code className="bg-gray-100 text-gray-700 px-1 rounded">JU_ScreenTranslator_v1.1.exe</code> 실행</li>
              <li>
                SmartScreen 경고가 뜨면 <span className="font-medium">추가 정보 → 실행</span>을 선택
              </li>
            </ol>
            <p className="text-xs text-gray-500 mt-3">
              * 실시간 보호가 자동으로 계속하여 파일을 지울 경우, 일시적으로 실시간 보호를 끄고 설치 후 <b>반드시</b> 다시 켜세요.
            </p>
          </div>

          {/* 면책 고지 */}
          <div className="rounded-2xl border border-red-200 bg-red-50 p-5">
            <h2 className="text-lg font-semibold text-red-800 mb-2">⚠ 면책 고지 (Disclaimer)</h2>
            <p className="text-sm text-red-900 leading-relaxed">
              본 프로그램은 제작자가 직접 개발·테스트한 것으로 악성 코드나 바이러스는 포함되어 있지 않습니다. 다만 일부 보안
              프로그램/Windows Defender에서 오탐지(잘못된 경고)가 발생할 수 있습니다. 사용자가 이를 무시하고 설치·실행하는 경우
              발생할 수 있는 모든 문제(데이터 손실, 시스템 오류 등)에 대해서는 제작자가 책임지지 않습니다. 설치·실행 여부는 전적으로
              사용자의 판단과 책임 하에 진행해 주시기 바랍니다.
            </p>
          </div>
        </section>
      </div>
    </div>

  );
}
